/**
 * author: Gautam Panickar
 */
import { withTranslation } from "react-i18next";
import { TEXT_TRUNCATION_MAX_LENGTH } from "../constants/common";
 
 const TruncatedText = (props) => {
    const truncate = (text) => {
        return text?.length > TEXT_TRUNCATION_MAX_LENGTH 
            ? text.substring(0, TEXT_TRUNCATION_MAX_LENGTH - 3) + "..." 
            : (text ?? '');
    };
    return <span title={`${props.text}`}>{truncate(props.text)}</span>;
 };
 export default withTranslation()(TruncatedText);